import { useState, useEffect } from "react"
import PropTypes from "prop-types"
import QuantitySelector from "@/components/cart/QuantitySelector"
import DisplayDiscountPrice from "@/components/Shared/DisplayDiscountPrice"
import {
  checkDiscontinuedStatus,
  getColors,
  getLineItemsProductImage,
  createSharedListUrl,
} from "@/components/MyFavorites/v1/MyList/helper"
import { getPDPUrl } from "@/utils/helper"
import ColorSwatchSelected from "@/components/MyFavorites/v1/MyList/ColorSwatchSelected/v1/index.jsx"
import { getProductPrice } from "@/components/MyFavorites/v1/MyList/helper"
import Button from "@/components/core/Button/Button"
import cx from "classnames"
import Image from "@/components/Shared/Image"
import wishIcon from "@/public/icons/wish.svg"
import wishIconFilled from "@/public/icons/wishlist-gray-filled.svg"
import MissingImage from "@/public/images/image-missing.png"
import OutOffStock from "@/public/icons/out-off-stock.svg"
import RequiredInstallationProducts from "@/public/icons/required-installation-icon.svg"
import useWindowResize from "@/hooks/useWindowResize"
import { getPresetUrl } from "@/utils/index"
import ListRequiredItemModal from "@/components/MyFavorites/v1/MyList/ListRequiredItemModal"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import ShareListModal from "@/components/ShareListModal"

const ShareListRowItem = props => {
  const {
    general,
    productQtyObj,
    qtyChange,
    product,
    presetConfigs,
    listItemsPrice,
    addToCart,
    disableAddToCart,
    lessStock,
    outOfStock,
    handleSingleItemToCart,
    availColorCTA,
    discontinuedText,
    requiredItemsToInstall,
    staticText = {},
    handleSingleItemToCartWithInstallItems,
    language,
    handleAddItemAndRemoveItemFromList,
    userListItemsSkus = {},
  } = props
  const {
    "productImages.url_ss": imageUrl,
    ProductBrandName_s: brandName,
    masterSKU_s: sku,
    ProductDescriptionProductShort_s: shortDescription,
    ProductIsRetail_s: isRetailExclusiveValue = false,
  } = product
  const isRetailExclusive = isRetailExclusiveValue === "true" ? true : false
  const requiredProductToInstall =
    listItemsPrice[`${sku}-RequiredAccessories`]?.length > 0 ? true : false
  const [tileUrl, setTileUrl] = useState("")
  const productBrandName = general?.siteName ?? ""

  const [showShareListModal, setShowShareListModal] = useState(false)
  const [showRequiredProductsModal, setShowRequiredProductsModal] =
    useState(false)
  const [showTooltip, setShowTooltip] = useState()
  const [width] = useWindowResize()
  const colors = getColors(product)
  const images = getLineItemsProductImage(product, sku)
  const { availableSkus = [] } = checkDiscontinuedStatus(product)
  const isProductDiscontinued = availableSkus.length === 0
  const isSkuDiscontinued =
    product["productRegionAllVariantDiscontinued_b"] ?? false
  const showAddToCart =
    !disableAddToCart &&
    !isSkuDiscontinued &&
    product?.stockStatus !== "Out of Stock"
  const showAvailableColors =
    !isProductDiscontinued && isSkuDiscontinued && availableSkus.length > 0
  const showActionButton = showAddToCart || showAvailableColors

  const handleImageClick = e => {
    if (e.target.className && e.target.className !== "checkbox__marker-icon") {
      e.stopPropagation()
      e.preventDefault()
      location.href = decodeURIComponent(`${tileUrl}?skuId=${sku}`)
    }
  }

  const handleShowRequiredProductsModalView = showhide => {
    setShowRequiredProductsModal(showhide)
  }

  const handleProductNameClick = () => {
    location.href = decodeURIComponent(`${tileUrl}?skuId=${sku}`)
  }

  const handleAvailableColorsClick = () => {
    location.href = decodeURIComponent(`${tileUrl}?skuId=${sku}`)
  }
  const handleAddToCartWithInstallItems = items => {
    setShowRequiredProductsModal(false)
    handleSingleItemToCartWithInstallItems(items, sku)
  }
  useEffect(() => {
    const category = product.Product_Category
      ? product.Product_Category
      : product.ProductLocalCategory_s ?? ""
    getPDPUrl(category, product.slug_s).then(ret => setTileUrl(ret))
  }, [product])

  const getOutOffStockText = () => {
    if (product?.stockStatus === "Less Stock") {
      return `${product?.inventory} ${lessStock}`
    } else if (product?.stockStatus === "Out of Stock") {
      return outOfStock
    }
    return ""
  }

  return (
    <div className="row list-item no-gutters">
      <div className="col-12 col-sm-6 mobile-full-width col-md-6 list-left ">
        <div className="list-item__summary">
          <a
            role="button"
            onClick={e => handleImageClick(e)}
            data-testid="view-product"
          >
            <div className="list-image-tile">
              {imageUrl?.[0] && images?.length > 0 ? (
                images?.map((id, i) => {
                  const imgUrl = getPresetUrl(
                    width,
                    0,
                    general.swatchUrl,
                    id,
                    JSON.parse(presetConfigs)
                  )
                  return (
                    <img
                      className="list-image"
                      key={id + "_IMG_" + i}
                      id={id + "_IMG_" + i}
                      role="presentation"
                      src={imgUrl}
                      imgsrc={imgUrl}
                    />
                  )
                })
              ) : (
                <Image
                  className="list-image"
                  src={MissingImage}
                  alt="missing-image"
                />
              )}
              <div
                className="list-item__share-icon"
                onClick={e => {
                  handleAddItemAndRemoveItemFromList(e, sku, false)
                }}
                data-testid="itemShareIcon"
              >
                <Image
                  src={
                    userListItemsSkus[sku] ? wishIconFilled?.src : wishIcon?.src
                  }
                  role="presentation"
                  alt="close"
                  width="15"
                  height="14"
                />
              </div>
            </div>
          </a>
          <section className="list-item__specs list-item__specs-tabs">
            <div className="row no-gutters">
              <div className="col-12 list-item-desc__name">
                <div
                  className={`${
                    colors && colors[0]?.name === "Not Applicable"
                      ? "visibilty"
                      : ""
                  }`}
                >
                  <ColorSwatchSelected
                    colors={colors}
                    cx={cx}
                    general={general}
                    mobile={true}
                    customText={staticText?.colorAndFinish}
                  />
                </div>
                {isSkuDiscontinued && (
                  <div className="list-item__badge">
                    <p className="badge-discontinued">{discontinuedText}</p>
                  </div>
                )}
                <div className="list-item__brand__list">
                  <span className="list-item__brand-name">
                    {productBrandName?.toUpperCase()}
                  </span>
                </div>
                <span
                  className="list-item__list-name"
                  onClick={handleProductNameClick}
                >
                  {brandName}
                </span>
                <p className="list-product-description-short">
                  {shortDescription}
                </p>
                <p className="list-product-description-short-sku">{sku}</p>
                {requiredProductToInstall ? (
                  <div className="list-product-required-products-to-install">
                    <div className="required-products-install">
                      <p
                        className="required-products-install-text"
                        onClick={() => {
                          handleShowRequiredProductsModalView(true)
                        }}
                      >
                        {requiredItemsToInstall}
                      </p>
                      <div className="text-line"></div>
                    </div>

                    <div className="required-products-install-icon">
                      <Image
                        src={RequiredInstallationProducts?.src}
                        role="presentation"
                        alt="close"
                        width="16"
                        height="16"
                        onMouseOver={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                      />
                      {showTooltip && (
                        <div className="tooltipWrapper">
                          <ToolTip
                            message={staticText?.requiredItemsToInstallToolTip}
                            pageName="list-details"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                ) : null}
                {product?.stockStatus === "Less Stock" ||
                product?.stockStatus === "Out of Stock" ? (
                  <div className="out-off-stock">
                    <div className="out-off-stock-icon">
                      <Image
                        src={OutOffStock?.src}
                        role="presentation"
                        alt="close"
                        width="16"
                        height="16"
                      />
                    </div>
                    <p className="out-off-stock-text">{getOutOffStockText()}</p>
                  </div>
                ) : null}
                {colors && colors[0]?.name === "Not Applicable" ? null : (
                  <ColorSwatchSelected
                    colors={colors}
                    cx={cx}
                    general={general}
                    mobile={false}
                    customText={staticText?.colorAndFinish}
                  />
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="col-12 col-sm-6 col-md-6 list-item__info print-right">
        <div className="row list-item__qty-price cart-qty-price-mobile mx-0 px-0">
          <div className="col-4  list-item__discount-container discount-container-padding ">
            <div className="list-item__price">
              <span className="list-details-price hide-mobile-price">
                {(disableAddToCart && isSkuDiscontinued) ||
                !listItemsPrice[sku] > 0 ? (
                  <span>-</span>
                ) : (
                  <DisplayDiscountPrice
                    formListDetails={true}
                    price={listItemsPrice[sku]}
                    discountedPrice={listItemsPrice[`${sku}-discount` ?? ""]}
                    currencySign={disableAddToCart ? "CAD $" : "$"}
                    data-testid="price-discount"
                  />
                )}
              </span>
            </div>
          </div>
          <div className="col-4 list-item__qty">
            <div className="quantity-selector no-print small">
              <QuantitySelector
                size="small"
                value={productQtyObj[sku] ?? 1}
                onChange={value => qtyChange(value, product)}
              />
            </div>
            {showActionButton && !disableAddToCart && !isRetailExclusive ? (
              <Button
                role="button"
                size="small"
                flexible={true}
                type={isSkuDiscontinued ? "black" : "ghost"}
                className={cx("quantity-selector__addToCard", {
                  "quantity-selector__availableColor": isSkuDiscontinued,
                })}
                onClick={() => {
                  isSkuDiscontinued
                    ? handleAvailableColorsClick()
                    : handleSingleItemToCart(
                        sku,
                        isSkuDiscontinued ? availColorCTA : addToCart
                      )
                }}
                label={isSkuDiscontinued ? availColorCTA : addToCart}
              />
            ) : null}
          </div>
          <div className="col-4 text-right list-item__total px-0 hide-price-popup-mobile ">
            <span className="list-details-price hide-mobile-price">
              {(disableAddToCart && isSkuDiscontinued) ||
              !listItemsPrice[sku] > 0 ? (
                <span>-</span>
              ) : (
                <DisplayDiscountPrice
                  price={getProductPrice(
                    product,
                    productQtyObj,
                    listItemsPrice
                  )}
                  currencySign={disableAddToCart ? "CAD $" : "$"}
                />
              )}
            </span>
          </div>
        </div>
        {showActionButton && !disableAddToCart && !isRetailExclusive ? (
          <Button
            role="button"
            size="small"
            flexible={true}
            type={isSkuDiscontinued ? "black" : "ghost"}
            className={cx("list-item__addToCard", {
              "quantity-selector__availableColor": isSkuDiscontinued,
            })}
            onClick={() => {
              isSkuDiscontinued
                ? handleAvailableColorsClick()
                : handleSingleItemToCart(
                    sku,
                    isSkuDiscontinued ? availColorCTA : addToCart
                  )
            }}
            label={isSkuDiscontinued ? availColorCTA : addToCart}
          />
        ) : null}
      </div>
      {showRequiredProductsModal ? (
        <ListRequiredItemModal
          staticTexts={staticText}
          showModal={showRequiredProductsModal}
          productRequiredAccessories={
            listItemsPrice[`${sku}-RequiredAccessories`] ?? []
          }
          listItemsPrice={listItemsPrice}
          customerFacingSKU={listItemsPrice[`${sku}-customerFacingSKU`]}
          productDetailData={product}
          onModalClose={() => {
            handleShowRequiredProductsModalView(false)
          }}
          handleAddToCartWithInstallItems={handleAddToCartWithInstallItems}
          isSkuDiscontinued={isSkuDiscontinued}
          productBackOrdered={
            listItemsPrice[`${sku}-RegionIsBackorderable`] ?? false
          }
        />
      ) : null}
      {showShareListModal ? (
        <ShareListModal
          showShareListModal={showShareListModal}
          URLToShare={createSharedListUrl(sku, language)}
          onClose={() => {
            setShowShareListModal(false)
          }}
        />
      ) : null}
    </div>
  )
}

ShareListRowItem.propTypes = {
  product: PropTypes.shape({
    "productImages.url_ss": PropTypes.array,
    ProductBrandName_s: PropTypes.string,
    masterSKU_s: PropTypes.string,
    ProductDescriptionProductShort_s: PropTypes.string,
    ProductIsRetail_s: PropTypes.string,
    Product_Category: PropTypes.string,
    ProductLocalCategory_s: PropTypes.string,
    slug_s: PropTypes.string,
    stockStatus: PropTypes.string,
    inventory: PropTypes.number,
    productRegionAllVariantDiscontinued_b: PropTypes.bool,
  }),
  general: PropTypes.object,
  productQtyObj: PropTypes.object,
  qtyChange: PropTypes.func,
  presetConfigs: PropTypes.string,
  listItemsPrice: PropTypes.object,
  addToCart: PropTypes.string,
  disableAddToCart: PropTypes.bool,
  lessStock: PropTypes.string,
  outOfStock: PropTypes.string,
  handleSingleItemToCart: PropTypes.func,
  availColorCTA: PropTypes.string,
  discontinuedText: PropTypes.string,
  requiredItemsToInstall: PropTypes.string,
  staticText: PropTypes.object,
  handleSingleItemToCartWithInstallItems: PropTypes.func,
  language: PropTypes.string,
  handleAddItemAndRemoveItemFromList: PropTypes.func,
  userListItemsSkus: PropTypes.object,
}

export default ShareListRowItem
